import React, { Component } from "react";
import "./CommonEnquiryForm.css";
import Notiflix from "notiflix";
import PostApiCall from "../helper/Api";

class CommonEnquiryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      pincode: "",
      mobile: "",
      email: "",
      errorMessage: "",
      DecimalRegex: /^(\d*\.?\d{0,2}|\.\d{0,9})$/,
      NumRegex: /^[0-9]*$/,
      PincodeRegex: /^[0-9]*$/,
      EmailRegex:
        /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.){1,2}[a-zA-Z]{2,4}$/,
    };
  }


  SaveEnquiry() {
    if (this.state.name != "") {
      if (this.state.mobile != "") {
        if (this.state.mobile.length == 10) {
          if (this.state.email === "" ||
            (this.state.email !== "" && this.state.EmailRegex.test(this.state.email))) {
            if (this.state.pincode != "") {
              if (this.state.pincode.length == 6) {
                this.onPost();
              } else {
                Notiflix.Notify.failure("Please enter valid pincode.");
              }
            } else {
              Notiflix.Notify.failure("Please enter area pincode.");
            }
          } else {
            Notiflix.Notify.failure("Please enter valid email.");
          }
        } else {
          Notiflix.Notify.failure("Please enter valid mobile number.");
        }
      } else {
        Notiflix.Notify.failure("Please enter mobile number.");
      }
    } else {
      Notiflix.Notify.failure("Please enter your name.");
    }
  }


  onPost = () => {
    Notiflix.Loading.dots("Please wait...");
    const page = window.location.pathname?.split('/p/')[1];
    // info @pioprinters.com
    PostApiCall.postRequest(
      {
        name: this.state.name,
        mobile: this.state.mobile,
        pincode: this.state.pincode,
        carton_type: page?.replace(/-/g, ' ') || '',
        email: this.state.email,
      },
      "monocartonsenquiry"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.remove();
          this.setState({
            name: "",
            pincode: "",
            mobile: "",
            email: ""
          })
          this.props.handleClose()
          Notiflix.Notify.success(
            "Thanks for Writing to us..! Our Team will Contact You Soon..."
          );
        } else {
          Notiflix.Loading.remove();
          Notiflix.Notify.failure(obj.data);
        }
      })
    );
  };

  render() {

    return (
      <div className="common-enquiry-form">
        {/* <button className="open-btn border-0" onClick={this.handleShow}>
          Click here for Quotes
        </button> */}

        <div className={`offcanvas ${this.props.showCanvas ? "show" : ""}`}>
          <div className="offcanvas-header">
            <h5>ENQUIRY</h5>
            <span className="close-btn" onClick={this.props.handleClose}>
              &times;
            </span>
          </div>
          <div className="offcanvas-body">
            <div className="enquiry-form h-100">
              <div className="form-section">
                <div className="row">
                  <div className="col-12 col-md-12">
                    <label className="mb-3">
                      Name: <span className="text-danger">*</span>
                      <input
                        className="mt-2"
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={(e) => this.setState({
                          name: e.target.value
                        })}
                        placeholder="Enter your name"
                      />
                    </label>
                  </div>

                  <div className="col-12 col-md-12">
                    <label className="mb-3">
                      Mobile:<span className="text-danger">*</span>
                      <div className="w-100 d-flex">
                        <span className="me-2 mt-2 d-flex align-items-center bg-dark text-white p-2 mobilenum-start-design">
                          +91
                        </span>
                        <input
                          className="mobilenum-input-design mt-2"
                          type="text"
                          name="mobile"
                          maxLength="10"
                          value={this.state.mobile}
                          onChange={
                            (e) => {
                              if (
                                this.state.NumRegex.test(e.target.value) &&
                                e.target.value.length <= 10
                              ) {
                                this.setState({
                                  mobile: e.target.value
                                })
                              }

                            }}
                          placeholder="Enter mobile number"
                        />
                      </div>
                    </label>
                  </div>
                  <div className="col-12 col-md-12">
                    <label className="mb-3">
                      Email:
                      <input
                        className="mt-2"
                        type="text"
                        name="Location"
                        value={this.state.email}
                        onChange={(e) => this.setState({
                          email: e.target.value
                        })}
                        placeholder="Enter your email"
                      />
                    </label>
                  </div>
                  <div className="col-12">
                    <label className="mb-3">
                      Pincode: <span className="text-danger">*</span>
                      <input
                        className="mt-2"
                        type="text"
                        name="pincode"
                        value={this.state.pincode}
                        onChange={
                          (e) => {
                            if (
                              this.state.PincodeRegex.test(e.target.value) &&
                              e.target.value.length <= 6
                            ) {
                              this.setState({
                                pincode: e.target.value
                              })
                            }

                          }}
                        placeholder="Enter your pincode"
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-section d-flex justify-content-end">
                <button type="submit" className="btn btn-cont-w3" onClick={this.SaveEnquiry.bind(this)}>
                  Submit Enquiry
                </button>
              </div>
            </div>
          </div>
        </div>

        {this.props.showCanvas && (
          <div className="overlay" onClick={this.props.handleClose}></div>
        )}
      </div>
    );
  }
}

export default CommonEnquiryForm;
